import { Api } from 'models/services/api';
import { CreateCentralKitchenQuery } from 'models/services/graphql';

import { CentralKitchenData, CentralKitchenDataToSave } from '../index';

type DataToCreate = {
  input: CentralKitchenDataToSave;
};

const RequestQuery = `
  mutation CreateCentralKitchen($input: CentralKitchenInput!) {
    ${CreateCentralKitchenQuery}
  }
`;

type ResponseData = {
  data: {
    createCentralKitchen: CentralKitchenData
  }
}

class CreateGql {

  readonly api: Api<ResponseData>;
  readonly document?: CentralKitchenData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToCreate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.createCentralKitchen;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { CreateGql };